import React from 'react';

const LogsView = ({
                      activeTab,
                      filters,
                      onFilterChange,
                      onApplyFilters,
                      onResetFilters,
                      onRefreshLogs,
                      isLoadingLogs,
                      stanbicLogs,
                      niraLogs,
                      expandedLogs,
                      onToggleLogExpansion,
                      scbPayments
                  }) => {
    return (
        <div className="logs-container">
            {/* Filter Section */}
            <div className="filter-section">
                <div className="filter-grid">
                    <div className="filter-group">
                        <label>Date From</label>
                        <input
                            type="date"
                            name="dateFrom"
                            value={filters.dateFrom}
                            onChange={onFilterChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label>Date To</label>
                        <input
                            type="date"
                            name="dateTo"
                            value={filters.dateTo}
                            onChange={onFilterChange}
                        />
                    </div>
                    <div className="filter-group">
                        <label>Search</label>
                        <input
                            type="text"
                            name="searchTerm"
                            placeholder="Search..."
                            value={filters.searchTerm}
                            onChange={onFilterChange}
                        />
                    </div>
                    {activeTab === 'stanbic' && (
                        <div className="filter-group">
                            <label>Operation Type</label>
                            <select
                                name="status"
                                value={filters.status}
                                onChange={onFilterChange}
                            >
                                <option value="">All Types</option>
                                <option value="CREATE">Create</option>
                                <option value="UPDATE">Update</option>
                                <option value="DELETE">Delete</option>
                            </select>
                        </div>
                    )}
                </div>
                <div className="filter-actions">
                    <button className="btn-primary" onClick={onApplyFilters}>
                        <i className="fas fa-filter"></i> Apply Filters
                    </button>
                    <button className="btn-secondary" onClick={onResetFilters}>
                        <i className="fas fa-redo"></i> Reset
                    </button>
                    <button className="btn-secondary" onClick={onRefreshLogs} disabled={isLoadingLogs}>
                        {isLoadingLogs ? (
                            <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                            <i className="fas fa-sync"></i>
                        )} Refresh
                    </button>
                </div>
            </div>

            {isLoadingLogs ? (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                    <p>Loading logs...</p>
                </div>
            ) : (
                <div className="logs-content">
                    {activeTab === 'stanbic' && (
                        <div className="table-container">
                            <table>
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Object Description</th>
                                    <th>Full Change</th>
                                    <th>Username</th>
                                    <th>IP Address</th>
                                    <th>Operation Type</th>
                                </tr>
                                </thead>
                                <tbody>

                                {stanbicLogs.length > 0 ? (
                                    stanbicLogs.map(log => (
                                        <React.Fragment key={log.id}>
                                            <tr
                                                onDoubleClick={() => onToggleLogExpansion(log.id)}
                                                className={expandedLogs[log.id] ? 'log-row-expanded' : 'log-row-collapsed'}
                                            >
                                                <td>{log.activityTime}</td>
                                                <td>{log.objectDescription}</td>
                                                <td>
                                                    {expandedLogs[log.id]
                                                        ? log.fullChange
                                                        : (log.fullChange && log.fullChange.length > 50
                                                            ? `${log.fullChange.substring(0, 50)}...`
                                                            : log.fullChange)
                                                    }
                                                </td>
                                                <td>{log.username}</td>
                                                <td>{log.ipAddress}</td>
                                                <td>
                                                        <span className={`status-badge ${log.crudOperationType?.toLowerCase()}`}>
                                                            {log.crudOperationType}
                                                        </span>
                                                </td>
                                            </tr>
                                            {expandedLogs[log.id] && (
                                                <tr className="log-detail-row">
                                                    <td colSpan="6">
                                                        <div className="log-detail-content">
                                                            <h4>Full Change Details:</h4>
                                                            <pre>{log.fullChange}</pre>
                                                            <button
                                                                className="btn-sm"
                                                                onClick={() => onToggleLogExpansion(log.id)}
                                                            >
                                                                Hide Details
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="no-data">No logs found</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {activeTab === 'nira' && (
                        <div className="table-container">
                            <table>
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Object Description</th>
                                    <th>Full Change</th>
                                    <th>Username</th>
                                    <th>IP Address</th>
                                    <th>Operation Type</th>
                                </tr>
                                </thead>
                                <tbody>

                                {niraLogs.length > 0 ? (
                                    niraLogs.map(log => (
                                        <React.Fragment key={log.id}>
                                            <tr
                                                onDoubleClick={() => onToggleLogExpansion(log.id)}
                                                className={expandedLogs[log.id] ? 'log-row-expanded' : 'log-row-collapsed'}
                                            >
                                                <td>{log.activityTime}</td>
                                                <td>{log.objectDescription}</td>
                                                <td>
                                                    {expandedLogs[log.id]
                                                        ? log.fullChange
                                                        : (log.fullChange && log.fullChange.length > 50
                                                            ? `${log.fullChange.substring(0, 50)}...`
                                                            : log.fullChange)
                                                    }
                                                </td>
                                                <td>{log.username}</td>
                                                <td>{log.ipAddress}</td>
                                                <td>
                                                        <span className={`status-badge ${log.crudOperationType?.toLowerCase()}`}>
                                                            {log.crudOperationType}
                                                        </span>
                                                </td>
                                            </tr>
                                            {expandedLogs[log.id] && (
                                                <tr className="log-detail-row">
                                                    <td colSpan="6">
                                                        <div className="log-detail-content">
                                                            <h4>Full Change Details:</h4>
                                                            <pre>{log.fullChange}</pre>
                                                            <button
                                                                className="btn-sm"
                                                                onClick={() => onToggleLogExpansion(log.id)}
                                                            >
                                                                Hide Details
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="no-data">No logs found</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {activeTab === 'scb' && (
                        <div className="logs-list">
                            {scbPayments.map(item => (
                                <div className="log-entry" key={`log-${item.id}`}>
                                    <div className="log-header">
                                        <span className="log-timestamp">{item.date}</span>
                                        <span className={`log-status ${item.status.toLowerCase()}`}>
                                            {item.status}
                                        </span>
                                    </div>
                                    <div className="log-message">
                                        {item.status} payment {item.reference} (UGX {item.amount.toLocaleString()})
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default LogsView;